import React from "react"
import {Route, Routes} from "react-router-dom"
import {GitTree} from "../../interfaces/repos"
import {Blob} from "../../pages/Repo/Code/Blob"
import {Tree} from "../../pages/Repo/Code/Tree"

export const RepoCodeRoutes = (props: { gitTree: GitTree, cloneCnt: number }) => {
  return (
    <Routes>
      <Route path="/tree/:branch/*" element={<Tree gitTree={props.gitTree} cloneCnt={props.cloneCnt}/>}/>
      <Route path="/blob/:branch/*" element={<Blob gitTree={props.gitTree} cloneCnt={props.cloneCnt}/>}/>
    </Routes>
  )
}
